import { action, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import './reset-password.css';
import InputField from '../../common/forms/input-field';
import PageFrameSingleForm from '../../common/page-frames/single-form';
import strings from '../../strings';

import { ResetPasswordProps } from '../../types';

@inject('resetPasswordStore')
@observer
class ResetPassword extends React.Component<ResetPasswordProps> {
  public render() {
    const store = this.props.resetPasswordStore!;
    const formAdditionalInfo = (
      <span>
        Already have an account?&nbsp;
        <a href="/sign-in" className="link has-text-primary">Log in.</a>
      </span>
    );

    return (
      <PageFrameSingleForm
          additionalInfo={formAdditionalInfo}
          formTitle={strings.texts.RESET_PASSWORD}
          path="sign-up"
          title={strings.texts.RESET_PASSWORD}
      >
        <InputField
            disabled={store.awaitServer}
            helpMessage={store.passwordHelpMessage}
            highlight={store.passwordHighlight}
            layoutClassName="column is-12 is-marginless"
            name="password"
            onBlur={this.handlePasswordBlur}
            onChange={this.handlePasswordChange}
            placeholder={strings.texts.PASSWORD}
            type="password"
            value={store.password}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.confirmPasswordHelpMessage}
            highlight={store.confirmPasswordHighlight}
            layoutClassName="column is-12 is-marginless"
            name="confirm"
            onBlur={this.handleConfirmPasswordBlur}
            onChange={this.handleConfirmPasswordChange}
            placeholder={strings.texts.CONFIRM_PASSWORD}
            type="password"
            value={store.confirmPassword}
        />

        <div className="column is-12 field is-marginless">
          <button
              className="button is-primary"
              disabled={store.awaitServer}
              onClick={this.handleSubmit}
              type="submit">
            {strings.texts.RESET_PASSWORD}
          </button>
        </div>
      </PageFrameSingleForm>
    );
  }

  /**
   * Handles password change
   */
  @action
  public handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.resetPasswordStore!.password = event.currentTarget.value;
  }

  /**
   * Handles comfirm password change
   */
  @action
  public handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.resetPasswordStore!.confirmPassword = event.currentTarget.value;
  }

  /**
   * Handles password blur
   */
  @action
  public handlePasswordBlur = () => {
    this.props.resetPasswordStore!.passwordBlurred = true;
  }
  
  /**
   * Handles confirm password blur
   */
  @action
  public handleConfirmPasswordBlur = () => {
    this.props.resetPasswordStore!.confirmPasswordBlurred = true;
  }

  /**
   * Handles submit action; disables all form controls.
   */
  @action
  public handleSubmit = async () => {
    const store = this.props.resetPasswordStore!;
    store.passwordBlurred = true;
    store.confirmPasswordBlurred = true;

    if (store.isReadyForSubmit) {
      const { uid, token } = this.props.match.params;

      try {
        await store.resetPassword(uid, token);
        this.props.history.push('/sign-in');
      } catch(error) {
        runInAction(() => store.awaitServer = false);
        console.error(error);
      }
    }
  };
}



export default ResetPassword;


// WEBPACK FOOTER //
// ./src/pages/reset-password/ResetPassword.tsx